// extracted by mini-css-extract-plugin
module.exports = {"feedback":"search_result_decision-module__feedback--1Z8b6","gradient":"search_result_decision-module__gradient--2f3Z1","wrapper":"search_result_decision-module__wrapper--19dxy"};